import { VerticallyAlignedBlogCardsWithShapedImage } from '@akyga/shared-ui/VerticallyAlignedBlogCardsWithShapedImage';

export default VerticallyAlignedBlogCardsWithShapedImage;
